<template>
  <div
    :class="[`bg-${color}`]"
    class="AngleSection section relative"
  >
    <div class="decor absolute pin-l pin-r">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        class="w-full block relative h-16"
        preserveAspectRatio="none"
      >
        <path
          :class="`text-${color}`"
          class="fill-current"
          stroke-width="0"
          d="M0 100 L100 0 L100 100"
        />
      </svg>
    </div>
    <slot/>
  </div>

</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: ''
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import 'utils';

.AngleSection {
  .decor {
    transform: translateY(1px);
    bottom: 100%;
  }
}
</style>
